module.exports = __webpack_public_path__ + "static/img/menuSpis-ON.f7cb2d80.png";